import MyBread from '../../components/Breadcrumbs'
import React, { Fragment, useEffect, useState, Dispatch, SetStateAction } from 'react'
import MaterialTable from 'material-table'
import { ThemeProvider, createTheme, CircularProgress } from '@mui/material';
import { useModal } from 'react-hooks-use-modal';
import { useForm, SubmitHandler } from "react-hook-form";
import { useAuth } from '../../hooks/use-auth';
import axios from 'axios';
import IdSearchButtonWithParent from '../../components/IdSearchButtonWithParent';
import IdSearchButton from 'components/IdSearchButton';
import config from 'config';
import { removeKeyWithValue } from 'utils';
import { Wrapper, PageTitle, ModalStyle, FormLabel, FormInput, FormLabelInputWrapper, ModalTitle, ModalSubTitle, ModalForm, ModalSubmit, LoadingContainer, ModalClose } from 'styles/styles';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
interface ParentProps {
	data: ParentDataProps[];
	setIsParentDataInsert: Dispatch<SetStateAction<boolean>>;
}

interface ParentDataProps {
	equipment_id: string
	color_code: string
	name: string
	name_kana: string
	abbreviation: string
	available_time: number
	status: string
	memo: string
}

interface OrderDataProps {
	records_order_id: number
	customer_id: number
	customer_display_id: string
	customer_name: string
	customer_branch_id: number
	customer_branch_display_id: string
	customer_branch_name: string
	charged_user_id: number
	charged_user_display_id: string
	charged_user_name: string
	memo: string
	display_id: string
	[key: string]: string | number;
}

const Parent = ({ data, setIsParentDataInsert }: ParentProps) => {
	const [processData, setProcessData] = React.useState<{ process_id: number, customer_factory_id: number }>({ process_id: 0, customer_factory_id: 0 });
	const auth = useAuth();
	const [isSubmitDisable, setIsSubmitDisable] = useState<boolean>(false);
	//modal
	const [modalTitle, setModalTitle] = React.useState('');
	const [modalSubText, setModalSubText] = React.useState('');
	const [Modal, open, close, isOpen] = useModal('root', { preventScroll: true, });
	const { reset, register, handleSubmit, setValue, watch, formState: { errors } } = useForm<OrderDataProps>();
	const onSubmit: SubmitHandler<OrderDataProps> = async (submitData: OrderDataProps) => {

		let alertList: any[] = [];
		const requiredFields = orderArray.filter(obj => obj.required === true).map(obj => obj.field);
		requiredFields.forEach((key) => {
			if (submitData[key] === undefined || submitData[key] === '') {
				alertList.push(key)
			}
		});
		if (alertList.length) {
			let text = '';
			orderArray.forEach(item => {
				if (alertList.includes(item.field)) {
					text += `${item.title}を埋めてください。\n`;
				}
			});
			if (text !== '') {
				alert(text);
				throw new Error('必須項目が未入力です');
			}
		}
		submitData = removeKeyWithValue(submitData, '');
		const branchData = {
			customer_id: submitData.customer_id,
			customer_display_id: submitData.customer_display_id,
			customer_name: submitData.customer_name,
			customer_branch_id: submitData.customer_branch_id,
			customer_branch_display_id: submitData.customer_branch_display_id,
			customer_branch_name: submitData.customer_branch_name,
			charged_user_id: submitData.charged_user_id,
			charged_user_display_id: submitData.charged_user_display_id,
			charged_user_name: submitData.charged_user_name,
			memo: submitData.memo,
			display_id: submitData.display_id
		}
		try {
			setIsSubmitDisable(true);
			const res = await axios.post(`/v0/factories/${auth.factoryId}/records-orders`, branchData, {
				headers: auth.authorizationHeader
			});
			const branchData2 = {
				customer_factory_id: processData.customer_factory_id,
				process_id: processData.process_id,
				order_id: res.data.insert_id,
			}
			await axios.patch(`/v0/factories/${auth.factoryId}/shared-processes`, branchData2, {
				headers: auth.authorizationHeader
			});
			window.alert("登録が完了しました");
			close();
			setIsParentDataInsert(true);
		} catch (error: any) {
			window.alert(error.response.data.error);
		}
		setIsSubmitDisable(false);
	};
	//modal end

	//arrayの生成

	const parentArray = [
		{ title: '', field: 'process_id' },
		{ title: '', field: 'customer_factory_id' },
		{ title: '得意先共有用ID', field: 'customer_factory_share_code' },
		{ title: '', field: 'customer_id' },
		{ title: '連携済得意先ID', field: 'customer_display_id' },
		{ title: '連携済得意先名', field: 'customer_name' },
		{ title: '製作数量', field: 'order_number' },
		{ title: '依頼納期', field: 'internal_deadline' },
		{ title: '依頼工程名', field: 'product_name' },
		{ title: '依頼時得意先工場名', field: 'customer_factory_name' },
		{ title: 'メモ', field: 'memo' },
		{ title: 'status', field: 'status' }
	]
	const PAGE_TITLE = "共有された工程"
	const columnsArray: any = [];
	for (const element of parentArray) {
		if (element.title) {
			columnsArray.push({
				title: element.title,
				field: element.field,
				cellStyle: {
					minWidth: 150,
					maxWidth: 150,
					whiteSpace: 'nowrap',
					overflow: 'hidden',
					textOverflow: 'ellipsis'
				}
			})
		}
	}

	const orderArray = [{ title: '受注管理No', field: 'display_id', default: '1', type: 'alphanumeric', required: true },
	{ title: '', field: 'customer_id', type: 'number' },
	{ title: '得意先ID', field: 'customer_display_id', default: '', required: true, disable: true },
	{ title: '得意先名', field: 'customer_name', default: '', required: true, disable: true },
	{ title: '', field: 'customer_branch_id', type: 'number' },
	{ title: '得意先枝番', field: 'customer_branch_display_id', default: '', required: true, disable: true },
	{ title: '得意先担当者名', field: 'customer_branch_name', default: '', search: 'customers', required: true, disable: true },
	{ title: '', field: 'charged_user_id' },
	{ title: '担当者ID', field: 'charged_user_display_id', default: '', disable: true, required: true },
	{ title: '担当者名', field: 'charged_user_name', default: '', disable: true, required: true, search: "users" },
	{ title: 'メモ', field: 'memo', default: 'メモ', type: 'text' }
	]

	const defaultObj: any = {};
	for (const element of orderArray) {
		defaultObj[element.field] = element.default;
	}

	const [selectedCustomerContents, setSelectedCustomerContents] = useState<any>('');
	const [selectedCustomerBranchContents, setSelectedCustomerBranchContents] = useState<any>('');

	useEffect(() => {
		setValue('customer_id', selectedCustomerContents.customer_id);
		setValue('customer_display_id', selectedCustomerContents.display_id);
		setValue('customer_name', selectedCustomerContents.name);
		setValue('customer_branch_id', selectedCustomerBranchContents.customer_branch_id)
		setValue('customer_branch_display_id', selectedCustomerBranchContents.display_id)
		setValue('customer_branch_name', selectedCustomerBranchContents.name)
	}, [selectedCustomerContents, selectedCustomerBranchContents]);
	const [selectedUserContents, setSelectedUserContents] = useState<any>('');

	useEffect(() => {
		setValue('charged_user_id', selectedUserContents.user_id);
		setValue('charged_user_display_id', selectedUserContents.display_id);
		setValue('charged_user_name', selectedUserContents.name);
	}, [selectedUserContents]);

	const listItems = orderArray.map((element: any, index) => {
		if (element.title) {
			return (
				<Fragment key={index}>
					<FormLabelInputWrapper>
						<FormLabel htmlFor={element.field}>{element.title}</FormLabel>
						<FormInput {...register(element.field)}
							{...(element.type && { type: config.inputErrorMessage[element.type].type })}
							{...(element.type && { placeholder: config.inputErrorMessage[element.type].placeholder })}
							{...(element.type && { pattern: config.inputErrorMessage[element.type].pattern })}
							{...(element.type && { title: config.inputErrorMessage[element.type].title })}
							{...(element.required && { required: true })}
							{...(element.disable && { disabled: true })}
							{...(element.type && { maxLength: config.inputErrorMessage[element.type].maxLength })}
							{...(element.type === "number" && { max: config.inputErrorMessage[element.type].max })}
						/>
						{element.search === "customers" ? <IdSearchButtonWithParent search={element.search} setSelectedContents={setSelectedCustomerContents} setSelectedBranchContents={setSelectedCustomerBranchContents} /> : <></>}
						{element.search === "users" ? <IdSearchButton search={element.search} setSelectedContents={setSelectedUserContents} /> : <></>}
					</FormLabelInputWrapper>
				</Fragment>
			)
		}
	}
	);
	//カラムなど生成ここまで

	const defaultMaterialTheme = createTheme();
	const [pageSize, setPageSize] = React.useState(5);

	//IDから既存の値を呼び出し
	async function setModalValue(process_id: number) {
		//データの取得axios
		const result: any = await axios.get(`/v0/factories/${auth.factoryId}/shared-processes`, {
			headers: auth.authorizationHeader,
			params: { id: process_id }
		});
		const resultData = result.data[0]
		setModalTitle("工程共有受領")
		setModalSubText(`得意先共有用ID:${resultData.customer_factory_share_code}\n製作数量:${resultData.order_number}\n依頼納期:${resultData.internal_deadline}\n依頼工程名:${resultData.product_name}\nメモ:${resultData.memo}`)
		const orderCount: any = await axios.get(`/v0/factories/${auth.factoryId}/records-orders`, {
			headers: auth.authorizationHeader,
			params: { type: "count" }
		});
		defaultObj.display_id = parseInt(orderCount.data[0].record_count) + 1;
		reset(defaultObj);
	}


	return (
		<>
			<ThemeProvider theme={defaultMaterialTheme}>
				<MaterialTable
					title={PAGE_TITLE}
					columns={columnsArray}
					data={data}
					actions={[
						rowData => ({
							icon: TaskAltIcon,
							tooltip: '受注登録する',
							hidden: !(rowData.status === '新規依頼'),
							onClick: async (event, rowData: any) => {
								event.preventDefault();
								try {
									await setModalValue(rowData.process_id);
									setProcessData({ process_id: rowData.process_id, customer_factory_id: rowData.customer_factory_id });
									reset(defaultObj)
									open();
								} catch (error) {
									console.log(error)
								}
							},
						}),
						rowData => ({
							icon: TaskAltIcon,
							tooltip: '削除受領',
							hidden: !(rowData.status === '削除依頼'),
							onClick: async (event, rowData: any) => {
								event.preventDefault();
								const result = window.confirm(`削除しますか？`);
								if (result) {
									try {
										const branchData = {
											customer_factory_id: rowData.customer_factory_id,
											process_id: rowData.process_id,
											action: 'delete'
										}
										await axios.patch(`/v0/factories/${auth.factoryId}/shared-processes`, branchData, {
											headers: auth.authorizationHeader
										});
										setIsParentDataInsert(true);
									} catch (error: any) {
										window.alert(error.response.data.error);
									}
								}
							}
						}),
						rowData => ({
							icon: DoDisturbIcon,
							tooltip: '拒否する',
							hidden: !(rowData.status === '新規依頼' || rowData.status === '削除依頼'),
							onClick: async (event, rowData: any) => {
								event.preventDefault();
								const result = window.confirm(`拒否しますか？`);
								if (result) {
									try {
										const branchData = {
											customer_factory_id: rowData.customer_factory_id,
											process_id: rowData.process_id,
											action: 'denied',
											type: rowData.status
										}
										await axios.patch(`/v0/factories/${auth.factoryId}/shared-processes`, branchData, {
											headers: auth.authorizationHeader
										});
										setIsParentDataInsert(true);
									} catch (error: any) {
										window.alert(error.response.data.error);
									}
								}
							}
						})
					]}
					options={{
						actionsColumnIndex: -1,
						headerStyle: { whiteSpace: 'nowrap' },
						rowStyle: { overflowWrap: 'break-word' }
					}}
					onChangeRowsPerPage={(pageSize) => {
						setPageSize(pageSize);
					}}
					onRowClick={(event: any, rowData: any) => {
						event.preventDefault();
					}}
				/>
			</ThemeProvider>

			<Modal>
				<ModalStyle>
					<ModalTitle>{modalTitle}</ModalTitle>
					<ModalSubTitle>{modalSubText}</ModalSubTitle>
					<ModalForm onSubmit={handleSubmit(onSubmit)}>
						{listItems}
						{isSubmitDisable ? (
							<LoadingContainer>
								<CircularProgress size={20} />
							</LoadingContainer>
						) : (
							<ModalSubmit type="submit" disabled={isSubmitDisable} />
						)}
					</ModalForm>
					<ModalClose onClick={close}>CLOSE</ModalClose>
				</ModalStyle>
			</Modal>
		</>
	)
}

export default function ProcessesRequested() {
	const auth = useAuth();
	const [isParentDataInsert, setIsParentDataInsert] = useState<boolean>(false);
	const [parentData, setParentData] = useState<ParentDataProps[]>([]);

	useEffect(() => {
		try {
			axios.get(`/v0/factories/${auth.factoryId}/shared-processes`, {
				headers: auth.authorizationHeader
			}).then((res: any) => {
				if (res.data.length) {
					setParentData(res.data);
				} else {
					setParentData([]);
				}
				setIsParentDataInsert(false)
			})
		} catch (err) {
			console.log(err)
		}
	}, [auth, isParentDataInsert]);

	return (
		<>
			<Wrapper>
				<MyBread />
				<PageTitle>共有された工程</PageTitle>
				<Parent data={parentData} setIsParentDataInsert={setIsParentDataInsert} />
			</Wrapper>
		</>
	)
}
